import React, { Component } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormGroup,
  Checkbox,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Paper,
  Avatar,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Chip
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { orange } from '@material-ui/core/colors';
import AssignmentIcon from '@material-ui/icons/Assignment';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteIcon from '@material-ui/icons/Delete';
import { actualizarMensaje } from "../../redux/actions/actGlobal";
import { connect } from "react-redux";
import {
  consulta, crear_form_data, mostrarError, obtenerValoresFiltros,
  generarFiltros, formulario, modificarValorGenericaAlter, obtenerPermisosValorAlt,
  obtenerValores, obtenerPermisosValor
} from "../../global/js/funciones";
import emma_w from '../../global/imagenes/emma_w.png';
import TareasTerminadas from '../general/TareasTerminadas';
import { CARRERAS, ESTADO, PREGUNTA_ENCUESTA_REGISTRO_ACOMPANAMIENTO, RESPUESTA_ENCUESTA_REGISTRO_ACOMPANAMIENTO, RESPUESTA_OTROS, TIPO_ACOMPANAMIENTO_DOCENTE,PREGUNTA_GRUPO_PRIORIZADO,RESPUESTA_GRUPO_PRIORIZADO,PREGUNTA_TIPO_CASO,RESPUESTA_NINGUNO } from './helper';

const styles = (theme) => ({
  container: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '0 16px'
  },
  card: {
    marginBottom: '20px',
    padding: '20px'
  },
  formControl: {
    minWidth: '100%',
    marginBottom: '20px'
  },
  textField: {
    width: '100%',
    marginBottom: '20px'
  },
  button: {
    marginTop: '20px',
    marginRight: '10px'
  },
  intro: {
    backgroundColor: '#f5f5f5',
    padding: '20px',
    borderRadius: '8px',
    marginBottom: '30px',
    borderLeft: '5px solid #B70E0C'
  },
  sectionTitle: {
    color: '#B70E0C',
    marginBottom: '15px',
    fontWeight: 'bold'
  },
  compactModal: {
    '& .MuiDialog-paper': {
      margin: theme.spacing(1),
      maxHeight: '90vh',
      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(0.5),
        maxHeight: '95vh'
      }
    }
  },
  modalTitle: {
    backgroundColor: '#B70E0C',
    color: 'white',
    padding: theme.spacing(1.5, 2),
    '& .MuiTypography-root': {
      fontSize: '1.1rem',
      fontWeight: 600
    }
  },
  modalContent: {
    padding: theme.spacing(1.5, 2),
    '& .MuiBox-root': {
      marginBottom: theme.spacing(1.5)
    }
  },
  questionTitle: {
    fontSize: '0.9rem',
    fontWeight: 500,
    marginBottom: theme.spacing(0.5),
    color: '#333'
  },
  compactFormGroup: {
    '& .MuiFormControlLabel-root': {
      marginBottom: theme.spacing(0.25),
      '& .MuiTypography-root': {
        fontSize: '0.85rem'
      }
    }
  },
  compactTextField: {
    '& .MuiInputBase-root': {
      fontSize: '0.9rem'
    },
    '& .MuiInputLabel-root': {
      fontSize: '0.9rem'
    }
  },
  modalActions: {
    padding: theme.spacing(1, 2),
    backgroundColor: '#f8f9fa',
    '& .MuiButton-root': {
      minWidth: 80,
      fontSize: '0.85rem'
    }
  }
});



class NuevoReporte extends Component {
  constructor(props) {
    super(props);
    this.state = {
      programaSeleccionado: '',
      asignaturaSeleccionada: '',
      asignaturaSeleccionadaObj: null, // Objeto completo de la asignatura seleccionada
      estudianteSeleccionado: '',
      modalPreguntas: false,
      respuestas: {},
      estudiantesReportados: [],
      modalDetalle: false,
      estudianteDetalle: null,
      dialogoConfirmacion: false,
      cargando: true,
      listarPrograma: [],
      materiasProfesor: [],
      estudiantesMateria: [],
      preguntasEncuesta: [],
      respuestasEncuesta: [],
      preguntasFormateadas: [], // Preguntas en formato para mostrar en UI
      tipos_acompanamientos: [],
      tipoAcompanamientoId: null
    };
  }

  componentDidMount() {
    this.setState({ cargando: true });
    this.cargarDatos();
  }

  ObtenerProgramasProfesor = () => {
    return new Promise((resolve) => {
      consulta(`api/v1.0/acompanamiento_docente/ObtenerProgramasProfesor`, null, null, (error, estado, resp) => {
        resolve(resp);
      });
    });
  }

  ObtenerDatosProfesor = (programa) => {
    return new Promise((resolve) => {
      consulta(`api/v1.0/acompanamiento_docente/ObtenerDatosProfesor/${programa}`, null, null, (error, estado, resp) => {
        resolve(resp);
      });
    });
  }

  ObtenerEstudiantesProfesor = (grupo) => {
    return new Promise((resolve) => {
      // Aseguramos que el grupo sea un número
      const grupoId = parseInt(grupo, 10);
      consulta(`api/v1.0/acompanamiento_docente/ObtenerEstudiantesProfesor/${grupoId}`, null, null, (error, estado, resp) => {
        resolve(resp);
      });
    });
  }

  cargarDatos = async () => {
    try {
      let programas = await this.ObtenerProgramasProfesor();
      let listarPrograma = [];
      let respuestasAcumuladas = [];
      let preguntasAcumuladas = [];
      if (!(programas.error)) {
        listarPrograma = await obtenerValoresFiltros([
          { 'llave': 'generica', 'valor': CARRERAS },
          { 'llave': 'estado', 'valor': ESTADO },
          { 'llave': 'codigos_in', 'valor': programas.programas }
        ]);
      }

      listarPrograma = listarPrograma.map((Val) => ({
        value: Val.id,
        label: Val.nombre,
        codigo: Val.codigo,
      }));

      this.setState({
        listarPrograma,
        cargando: false
      });

      const transformar = (data) => {
        return data.map((item) => ({
          id: item.id,
          nombre: item.nombre,
          tipo: item.valora,
          posicion: item.valorc,
          obligatorio: Boolean(item.valorb),
          condicion: item.valord
        }));
      };

      const transformarRespuestas = (datos) => {
        let respuestas = [];
        datos.map(({ secundario, principal }) => {
          let { id, nombre, valorb } = secundario;
          respuestas.push({
            id: id,
            nombre: `${nombre}`,
            posicion: valorb,
            id_pregunta: principal.id
          });
          return true;
        });
        return respuestas;
      };

      let preguntasAPI = await obtenerValores(PREGUNTA_ENCUESTA_REGISTRO_ACOMPANAMIENTO);
      preguntasAPI.sort((a, b) => (a.valorc > b.valorc ? 1 : -1));
      preguntasAPI = transformar(preguntasAPI);

      for (const { id } of preguntasAPI) {
        let preguntasResp = await obtenerPermisosValor(id);
        preguntasResp.sort((a, b) =>
          parseInt(a.secundario.valorb) > parseInt(b.secundario.valorb)
            ? 1
            : -1
        );

        let respuestasTemp = [];
        respuestasTemp.push(transformarRespuestas(preguntasResp));
        respuestasAcumuladas.push(respuestasTemp);
      }

      // Relacionar preguntas con respuestas y formatear para UI
      const preguntasFormateadas = preguntasAPI.map(pregunta => {
        // Buscar las respuestas que corresponden a esta pregunta
        const respuestasPregunta = respuestasAcumuladas
          .flat(2) // Aplanar el array anidado
          .filter(respuesta => respuesta.id_pregunta === pregunta.id)
          .sort((a, b) => parseInt(a.posicion) - parseInt(b.posicion));

        return {
          ...pregunta,
          respuestas: respuestasPregunta
        };
      }).sort((a, b) => parseInt(a.posicion) - parseInt(b.posicion));

      const transformarTipos = data => {
        return data.map(e => ({
          value: e.id,
          label: e.nombre,
          codigo: e.codigo,
        }));
      }
      const tipos_acompanamientos = await obtenerValores(TIPO_ACOMPANAMIENTO_DOCENTE);

      this.setState({
        preguntasEncuesta: preguntasAPI,
        respuestasEncuesta: respuestasAcumuladas,
        preguntasFormateadas,
        tipos_acompanamientos: transformarTipos(tipos_acompanamientos),
        tipoAcompanamientoId: tipos_acompanamientos[0]?.id || null
      });

    } catch (error) {
      this.setState({ cargando: false });
      this.props.actualizarMensaje({ titulo: 'Error cargando datos iniciales', tipo: 'error', mostrar: true, tiempo: 4000 });
    }
  }

  handleRespuestaChange = (preguntaId, valor) => {
    this.setState(prevState => ({
      respuestas: {
        ...prevState.respuestas,
        [preguntaId]: valor
      }
    }));
  }

  obtenerPreguntasVisibles = () => {
    const { preguntasFormateadas, respuestas } = this.state;
    
    // Siempre mostrar la pregunta inicial (ID PREGUNTA_GRUPO_PRIORIZADO)
    let preguntasVisibles = preguntasFormateadas.filter(p => p.id === PREGUNTA_GRUPO_PRIORIZADO);
    
    // Si ya respondió la pregunta PREGUNTA_GRUPO_PRIORIZADO
    if (respuestas[PREGUNTA_GRUPO_PRIORIZADO]) {
      // Si seleccionó "No" (no es ID RESPUESTA_GRUPO_PRIORIZADO), mostrar pregunta PREGUNTA_TIPO_CASO y las demás
      if (respuestas[PREGUNTA_GRUPO_PRIORIZADO] !== RESPUESTA_GRUPO_PRIORIZADO) {
        preguntasVisibles = preguntasFormateadas.filter(p => p.id !== PREGUNTA_GRUPO_PRIORIZADO);
        preguntasVisibles.unshift(preguntasFormateadas.find(p => p.id === PREGUNTA_GRUPO_PRIORIZADO));
      } else {
        // Si seleccionó "Sí" (ID RESPUESTA_GRUPO_PRIORIZADO), mostrar todas excepto la PREGUNTA_TIPO_CASO
        preguntasVisibles = preguntasFormateadas.filter(p => p.id !== PREGUNTA_TIPO_CASO);
      }
    }
    
    return preguntasVisibles;
  }

  renderPregunta = (pregunta) => {
    const { classes } = this.props;
    const { respuestas } = this.state;
    const valorSeleccionado = respuestas[pregunta.id];

    switch (pregunta.tipo) {
      case 'radio':
        return (
          <div key={pregunta.id}>
            <FormControl component="fieldset" className={classes.formControl} required={pregunta.obligatorio}>
              <Typography className={classes.questionTitle}>
                {pregunta.nombre} {pregunta.obligatorio && '*'}
              </Typography>
              <RadioGroup
                value={valorSeleccionado ? valorSeleccionado.toString() : ''}
                onChange={(e) => this.handleRespuestaChange(pregunta.id, parseInt(e.target.value))}
                className={classes.compactFormGroup}
              >
                {pregunta.respuestas.map((respuesta) => (
                  <FormControlLabel
                    key={respuesta.id}
                    value={respuesta.id.toString()}
                    control={<Radio size="small" />}
                    label={respuesta.nombre}
                  />
                ))}
              </RadioGroup>
            </FormControl>
            {valorSeleccionado === RESPUESTA_OTROS && (
              <TextField
                fullWidth
                multiline
                rows={2}
                value={respuestas[`otro_${pregunta.id}`] || ''}
                onChange={(e) => this.handleRespuestaChange(`otro_${pregunta.id}`, e.target.value)}
                placeholder="Especifique..."
                variant="outlined"
                size="small"
                className={classes.compactTextField}
                required
              />
            )}
          </div>
        );

      case 'checkbox':
        return (
          <div key={pregunta.id}>
            <FormControl component="fieldset" className={classes.formControl} required={pregunta.obligatorio}>
              <Typography className={classes.questionTitle}>
                {pregunta.nombre} {pregunta.obligatorio && '*'}
              </Typography>
              <FormGroup className={classes.compactFormGroup}>
                {pregunta.respuestas.map((respuesta) => (
                  <FormControlLabel
                    key={respuesta.id}
                    control={
                      <Checkbox
                        size="small"
                        checked={(respuestas[pregunta.id] || []).includes(respuesta.id)}
                        onChange={(e) => this.handleCheckboxChange(pregunta.id, respuesta.id, e.target.checked)}
                      />
                    }
                    label={respuesta.nombre}
                  />
                ))}
              </FormGroup>
            </FormControl>
            {(respuestas[pregunta.id] || []).includes(RESPUESTA_OTROS) && (
              <TextField
                fullWidth
                multiline
                rows={2}
                value={respuestas[`otro_${pregunta.id}`] || ''}
                onChange={(e) => this.handleRespuestaChange(`otro_${pregunta.id}`, e.target.value)}
                placeholder="Especifique..."
                variant="outlined"
                size="small"
                className={classes.compactTextField}
                required
              />
            )}
          </div>
        );

      case 'texto':
        return (
          <TextField
            key={pregunta.id}
            label={`${pregunta.nombre} ${pregunta.obligatorio ? '*' : ''}`}
            multiline
            rows={3}
            value={respuestas[pregunta.id] || ''}
            onChange={(e) => this.handleRespuestaChange(pregunta.id, e.target.value)}
            className={`${classes.textField} ${classes.compactTextField}`}
            required={pregunta.obligatorio}
            variant="outlined"
            size="small"
          />
        );

      default:
        return null;
    }
  }

  handleRespuestaChange = (preguntaId, valor) => {
    this.setState({
      respuestas: {
        ...this.state.respuestas,
        [preguntaId]: valor
      }
    });
  }

  handleCheckboxChange = (preguntaId, respuestaId, checked) => {
    const respuestasActuales = this.state.respuestas[preguntaId] || [];
    let nuevasRespuestas;

    if (checked) {
      nuevasRespuestas = [...respuestasActuales, respuestaId];
    } else {
      nuevasRespuestas = respuestasActuales.filter(id => id !== respuestaId);
    }

    this.setState({
      respuestas: {
        ...this.state.respuestas,
        [preguntaId]: nuevasRespuestas
      }
    });
  }

  handleProgramaChange = async (event) => {
    const programaSelected = this.state.listarPrograma.find(p => p.value === event.target.value);

    this.setState({
      programaSeleccionado: event.target.value,
      asignaturaSeleccionada: '',
      estudianteSeleccionado: '',
      cargando: true
    });

    if (programaSelected) {
      try {
        const datosProfesor = await this.ObtenerDatosProfesor(programaSelected.codigo);
        // Usamos un valor único que incluya el id_grupo para cada asignatura
        const materiasProfesor = datosProfesor.materias.map((e) => ({
          value: `${e.cod_materia}_${e.id_grupo}`, // Valor único que incluye el id_grupo
          label: `${e.nombre_grupo} - ${e.nombre_materia}`,
          codigo: e.cod_materia,
          cod_pensum: e.cod_pensum,
          cod_unidad: e.cod_unidad,
          id_grupo: e.id_grupo,
          nombre_materia: e.nombre_materia,
          nombre_grupo: e.nombre_grupo,
        }));

        this.setState({
          materiasProfesor,
          cargando: false
        });
      } catch (error) {
        this.setState({ cargando: false });
        this.props.actualizarMensaje({ titulo: 'Error al cargar las asignaturas', tipo: 'error', mostrar: true, tiempo: 4000 });
      }
    } else {
      this.setState({ cargando: false });
    }
  };

  handleAsignaturaChange = async (event) => {
    const asignaturaValue = event.target.value;

    // Buscar la asignatura exacta por su valor único
    const asignaturaSelected = this.state.materiasProfesor.find(a => a.value === asignaturaValue);

    this.setState({
      asignaturaSeleccionada: asignaturaValue,
      estudianteSeleccionado: '',
      cargando: true,
      asignaturaSeleccionadaObj: asignaturaSelected // Guardamos el objeto completo de la asignatura
    });

    if (asignaturaSelected && asignaturaSelected.id_grupo) {
      try {
        // Usamos el id_grupo exacto de la asignatura seleccionada
        const idGrupo = asignaturaSelected.id_grupo;


        const datosEstudiantes = await this.ObtenerEstudiantesProfesor(idGrupo);

        if (datosEstudiantes && datosEstudiantes.estudiantes) {
          const estudiantesMateria = datosEstudiantes.estudiantes.map((e) => ({
            value: e.num_identificacion_estudiante,
            label: `${e.nom_largo}`,
            codigo: e.num_identificacion_estudiante
          }));


          this.setState({
            estudiantesMateria,
            cargando: false
          });
        } else {
          this.setState({
            estudiantesMateria: [],
            cargando: false
          });
          this.props.actualizarMensaje({ titulo: `No se recibieron datos de estudiantes válidos para grupo ${idGrupo}`, tipo: 'warning', mostrar: true, tiempo: 4000 });
        }
      } catch (error) {
        this.setState({
          estudiantesMateria: [],
          cargando: false
        });
        this.props.actualizarMensaje({ titulo: 'Error al cargar los estudiantes', tipo: 'error', mostrar: true, tiempo: 4000 });
      }
    } else {
      this.setState({
        estudiantesMateria: [],
        cargando: false
      });
      this.props.actualizarMensaje({ titulo: 'No se encontró el grupo para la asignatura seleccionada', tipo: 'warning', mostrar: true, tiempo: 4000 });
    }
  };

  handleEstudianteChange = (event) => {
    const estudianteId = event.target.value;
    const { estudiantesReportados } = this.state;

    // Verificar si el estudiante ya fue reportado
    const yaReportado = estudiantesReportados.some(reporte =>
      reporte.estudiante.value === estudianteId
    );

    if (yaReportado) {
      this.props.actualizarMensaje({ titulo: 'Este estudiante ya ha sido reportado', tipo: 'warning', mostrar: true, tiempo: 4000 });
      this.setState({ estudianteSeleccionado: '' });
      return;
    }

    this.setState({
      estudianteSeleccionado: estudianteId,
      modalPreguntas: true,
      respuestas: {}
    });
  };

  validarRespuestas = () => {
    const { respuestas, preguntasFormateadas } = this.state;

    // Si no hay preguntas formateadas, no podemos validar
    if (!preguntasFormateadas || preguntasFormateadas.length === 0) return false;

    // Obtener las preguntas visibles según la lógica actual
    const preguntasVisibles = this.obtenerPreguntasVisibles();

    // Validar solo las preguntas visibles y obligatorias
    for (const pregunta of preguntasVisibles) {
      if (pregunta.obligatorio) {
        const respuesta = respuestas[pregunta.id];

        // Verificar si hay respuesta
        if (!respuesta) return false;
        
        // Para checkbox, verificar que haya al menos una opción seleccionada
        if (pregunta.tipo === 'checkbox' && Array.isArray(respuesta) && respuesta.length === 0) return false;

        // Para texto, verificar que no esté vacío
        if (pregunta.tipo === 'texto' && !respuesta.trim()) return false;
      }
    }

    return true;
  };

  handleCheckboxChange = (preguntaId, respuestaId, checked) => {
    const respuestasActuales = this.state.respuestas[preguntaId] || [];
    let nuevasRespuestas;

    if (checked) {
      nuevasRespuestas = [...respuestasActuales, respuestaId];
    } else {
      nuevasRespuestas = respuestasActuales.filter(id => id !== respuestaId);
    }

    this.setState({
      respuestas: {
        ...this.state.respuestas,
        [preguntaId]: nuevasRespuestas
      }
    });
  };

  guardarRespuestas = () => {
    if (!this.validarRespuestas()) {
      this.props.actualizarMensaje({ titulo: 'Por favor complete todos los campos obligatorios', tipo: 'warning', mostrar: true, tiempo: 4000 });
      return;
    }

    const { estudianteSeleccionado, respuestas, asignaturaSeleccionadaObj, estudiantesReportados, estudiantesMateria, preguntasFormateadas } = this.state;
    const estudiante = estudiantesMateria.find(e => e.value === estudianteSeleccionado);

    const asignatura = asignaturaSeleccionadaObj;

    // Verificar que todas las preguntas tengan respuesta
    let descripcionGeneralEncontrada = false;

    preguntasFormateadas.forEach(pregunta => {
      if (pregunta.obligatorio && !respuestas[pregunta.id]) {
        // Pregunta sin respuesta - se maneja en validación
      } else {
        // Verificar si es la descripción general
        if (pregunta.nombre.toLowerCase().includes('descripción general') ||
          pregunta.nombre.toLowerCase().includes('descripcion general')) {
          descripcionGeneralEncontrada = true;
        }
      }
    });

    // Si no se encontró la descripción general, agregar un valor por defecto
    const respuestasCompletas = { ...respuestas };
    if (!descripcionGeneralEncontrada) {
      // Buscar la pregunta de descripción general
      const preguntaDescripcion = preguntasFormateadas.find(p =>
        p.nombre.toLowerCase().includes('descripción general') ||
        p.nombre.toLowerCase().includes('descripcion general')
      );

      if (preguntaDescripcion) {
        respuestasCompletas[preguntaDescripcion.id] = 'Sin descripción';
      }
    }

    const nuevoReporte = {
      estudiante,
      asignatura,
      programa: this.state.listarPrograma.find(p => p.value === this.state.programaSeleccionado),
      respuestas: respuestasCompletas
    };

    this.setState({
      estudiantesReportados: [...estudiantesReportados, nuevoReporte],
      modalPreguntas: false,
      estudianteSeleccionado: ''
    });
  };

  verDetalle = (estudiante) => {
    this.setState({
      modalDetalle: true,
      estudianteDetalle: estudiante
    });
  };

  eliminarReporte = (index) => {
    const nuevosReportes = this.state.estudiantesReportados.filter((_, i) => i !== index);
    this.setState({ estudiantesReportados: nuevosReportes });
  };

  enviarReportes = () => {
    if (this.state.estudiantesReportados.length === 0) {
      this.props.actualizarMensaje({ titulo: 'Debe reportar al menos un estudiante', tipo: 'warning', mostrar: true, tiempo: 4000 });
      return;
    }
    this.setState({ dialogoConfirmacion: true });
  };

  confirmarEnvio = async () => {
    this.setState({ cargando: true });

    const { estudiantesReportados, respuestasEncuesta, tipoAcompanamientoId } = this.state;
    const data = new FormData();

    // Agregar el total de reportes
    data.append('total', estudiantesReportados.length.toString());
    // Agregar el ID del profesor
    data.append('profesor_id', this.props.usuario.id);
    // Agregar el ID del tipo de acompañamiento
    data.append('tipo_acompanamiento_id', tipoAcompanamientoId);

    // Agregar cada reporte al FormData
    estudiantesReportados.forEach((reporte, index) => {
      // Datos básicos del estudiante y asignatura
      data.append(`reporte${index}_estudiante`, reporte.estudiante.value);
      data.append(`reporte${index}_asignatura`, reporte.asignatura.nombre_materia);
      data.append(`reporte${index}_grupo`, reporte.asignatura.nombre_grupo);
      data.append(`reporte${index}_programa`, reporte.programa.codigo);
      data.append('crear_acompanamiento', 'docente');

      // Crear un objeto con la estructura exacta requerida
      const respuestasFormateadas = {
        verificacion_grupo: null, // Se actualizará con el valor seleccionado
        descripcion_general: "", // Valor por defecto
        seguimiento_realizado: "", // Valor por defecto
        clasificacion_casos: [RESPUESTA_NINGUNO], // Valor por defecto con al menos un elemento
        requiere_remi:null
      };

      // Buscar las preguntas por su contenido para mapear correctamente
      this.state.preguntasFormateadas.forEach(pregunta => {
        const respuesta = reporte.respuestas[pregunta.id];
        console.log('Pregunta:', pregunta.nombre, 'Respuesta:', respuesta);

        // Descripción general del tipo de caso (texto)
        if (pregunta.nombre.toLowerCase().includes('descripción general') ||
          pregunta.nombre.toLowerCase().includes('descripcion general')) {
          // Asignar directamente la respuesta si existe
          if (respuesta) {
            respuestasFormateadas.descripcion_general = respuesta;
          }
        }

        // Seguimiento realizado (texto)
        else if (pregunta.nombre.toLowerCase().includes('describa seguimiento')) {
          respuestasFormateadas.seguimiento_realizado = respuesta || '';
        }

        // Verificación El estudiante requiere remisión(radio button) - DEBE IR ANTES
        else if (pregunta.nombre.toLowerCase().includes('requiere remisión') ||
          pregunta.nombre.toLowerCase().includes('requiere remision') ||
          pregunta.nombre.toLowerCase().includes('remitido')) {
          console.log('Encontrada pregunta de remisión:', pregunta.nombre, 'Respuesta:', respuesta);
          if (respuesta) {
            respuestasFormateadas.requiere_remi = respuesta;
          }
        }

        // Verificación grupo priorizado (radio button)
        else if (pregunta.nombre.toLowerCase().includes('priorizado')) {
          if (respuesta) {
            respuestasFormateadas.verificacion_grupo = respuesta;
          }
        } 

        // Clasificación tipo de caso (checkbox - multiple)
        else if (pregunta.nombre.toLowerCase().includes('tipo de caso')) {
          if (Array.isArray(respuesta) && respuesta.length > 0) {
            respuestasFormateadas.clasificacion_casos = respuesta;
          }
        }
      });

      // Verificar si hay observaciones de "Otro" en cualquier pregunta
      this.state.preguntasFormateadas.forEach(pregunta => {
        const respuesta = reporte.respuestas[pregunta.id];
        const observacionOtro = reporte.respuestas[`otro_${pregunta.id}`];

        if (observacionOtro) {
          // Para radio
          if (pregunta.tipo === 'radio' && respuesta === RESPUESTA_OTROS) {
            respuestasFormateadas.otro_tipo_caso = observacionOtro;
          }
          // Para checkbox
          else if (pregunta.tipo === 'checkbox' && Array.isArray(respuesta) && respuesta.includes(RESPUESTA_OTROS)) {
            respuestasFormateadas.otro_tipo_caso = observacionOtro;
          }
        }
      });

      // Si aún no tiene valor, usar 1 como fallback
      if (respuestasFormateadas.verificacion_grupo === null) {
        respuestasFormateadas.verificacion_grupo = 1;
      }

      // Agregar las respuestas formateadas al FormData
      data.append(`reporte${index}_respuestas`, JSON.stringify(respuestasFormateadas));
    });

    this.props.actualizarMensaje({ titulo: 'Enviando datos, por favor espere...', tipo: 'info', mostrar: true, tiempo: 4000 });
    formulario(`api/v1.0/acompanamiento_docente/crear`, data, "post", (error, estado, resp) => {
      let titulo = 'Ha ocurrido un error, contacte con el administrador.', tipo = 'error';
      if (!error) {
        if (estado === 200) {
          tipo = 'success';
          titulo = resp.titulo;
          this.setState({
            programaSeleccionado: '',
            asignaturaSeleccionada: '',
            estudiantesReportados: [],
            dialogoConfirmacion: false,
            cargando: false
          });
        } else {
          tipo = 'info';
          titulo = resp.titulo ? resp.titulo : mostrarError(resp);
          this.setState({ cargando: false, dialogoConfirmacion: false });
        }
      } else {
        this.setState({ cargando: false, dialogoConfirmacion: false });
      }
      this.props.actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
    });
  };

  render() {
    const { classes } = this.props;
    const {
      programaSeleccionado,
      asignaturaSeleccionada,
      estudianteSeleccionado,
      modalPreguntas,
      respuestas,
      estudiantesReportados,
      modalDetalle,
      estudianteDetalle,
      dialogoConfirmacion,
      cargando
    } = this.state;

    const asignaturasDisponibles = programaSeleccionado ? this.state.materiasProfesor || [] : [];
    const estudiantesDisponibles = asignaturaSeleccionada ? this.state.estudiantesMateria || [] : [];

    return (
      <div className={classes.container}>
        {cargando ? (
          <TareasTerminadas mensaje={'Cargando...'} marginTop='7%' imagen={emma_w} widthImg='7%' cargando={true} />
        ) : (
          <>
            <Card className={classes.intro}>
              <Typography variant="body1">
                Seleccione el programa académico, luego la asignatura y finalmente los estudiantes que desea reportar.
              </Typography>
            </Card>

            <Card className={classes.card}>
              <CardContent>
                <Typography variant="h5" className={classes.sectionTitle}>
                  Registro de Acompañamiento Docente
                </Typography>

                <FormControl className={classes.formControl} disabled={cargando}>
                  <InputLabel>Programa Académico *</InputLabel>
                  <Select
                    value={programaSeleccionado}
                    onChange={this.handleProgramaChange}
                  >
                    {this.state.listarPrograma.map((programa) => (
                      <MenuItem key={programa.value} value={programa.value}>
                        {programa.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl className={classes.formControl} disabled={!programaSeleccionado || cargando}>
                  <InputLabel>Asignatura *</InputLabel>
                  <Select
                    value={asignaturaSeleccionada}
                    onChange={this.handleAsignaturaChange}
                  >
                    {asignaturasDisponibles.map((asignatura) => (
                      <MenuItem key={asignatura.value} value={asignatura.value}>
                        {asignatura.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl className={classes.formControl} disabled={!asignaturaSeleccionada || cargando}>
                  <InputLabel>Estudiante a reportar *</InputLabel>
                  <Select
                    value={estudianteSeleccionado}
                    onChange={this.handleEstudianteChange}
                  >
                    {estudiantesDisponibles.map((estudiante) => (
                      <MenuItem key={estudiante.value} value={estudiante.value}>
                        {estudiante.value} - {estudiante.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </CardContent>
            </Card>

            {estudiantesReportados.length > 0 && (
              <Card className={classes.card}>
                <CardContent>
                  <Typography variant="h6" className={classes.sectionTitle}>
                    Estudiantes Reportados ({estudiantesReportados.length})
                  </Typography>
                  <List>
                    {estudiantesReportados.map((reporte, index) => (
                      <ListItem key={index}>
                        <ListItemText
                          primary={reporte.estudiante.label}
                          secondary={`${reporte.asignatura.codigo} - ${reporte.asignatura.label}`}
                        />
                        <ListItemSecondaryAction>
                          <IconButton onClick={() => this.verDetalle(reporte)}>
                            <VisibilityIcon />
                          </IconButton>
                          <IconButton onClick={() => this.eliminarReporte(index)}>
                            <DeleteIcon />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                  </List>
                  <Box textAlign="center" marginTop={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.enviarReportes}
                      size="large"
                    >
                      Enviar Todos los Reportes
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            )}
          </>
        )}

        {/* Modal de Preguntas */}
        <Dialog
          open={modalPreguntas}
          maxWidth="sm"
          fullWidth
          className={classes.compactModal}
          scroll="body"
        >
          <DialogTitle className={classes.modalTitle}>
            Registro de Acompañamiento
          </DialogTitle>
          <DialogContent className={classes.modalContent}>
            {this.obtenerPreguntasVisibles().map((pregunta) => (
              <Box key={pregunta.id}>
                {this.renderPregunta(pregunta)}
              </Box>
            ))}
          </DialogContent>
          <DialogActions className={classes.modalActions}>
            <Button
              onClick={() => this.setState({ modalPreguntas: false })}
              size="small"
            >
              Cancelar
            </Button>
            <Button
              onClick={this.guardarRespuestas}
              color="primary"
              variant="contained"
              size="small"
            >
              Guardar
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal de Detalle */}
        <Dialog
          open={modalDetalle}
          maxWidth="sm"
          fullWidth
          className={classes.compactModal}
          scroll="body"
        >
          <DialogTitle className={classes.modalTitle}>
            Detalle del Reporte
          </DialogTitle>
          <DialogContent className={classes.modalContent}>
            {estudianteDetalle && (
              <div>
                <Box mb={1.5} p={1.5} bgcolor="#f8f9fa" borderRadius={1}>
                  <Typography variant="subtitle1" style={{ fontWeight: 600, color: '#B70E0C' }}>
                    {estudianteDetalle.estudiante.label}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {estudianteDetalle.asignatura.nombre_materia}
                  </Typography>
                  {/*  <Typography variant="caption" color="textSecondary">
                    Fecha: {estudianteDetalle.fecha}
                  </Typography> */}
                </Box>

                {this.state.preguntasFormateadas && this.state.preguntasFormateadas.map((pregunta) => {
                  const respuesta = estudianteDetalle.respuestas[pregunta.id];
                  const observacionOtro = estudianteDetalle.respuestas[`otro_${pregunta.id}`];
                  let valorMostrar = 'Sin respuesta';
                  let mostrarObservacion = false;

                  if (respuesta) {
                    if (Array.isArray(respuesta)) {
                      // Para checkbox, mostrar los nombres de las respuestas seleccionadas
                      const nombresRespuestas = respuesta.map(id => {
                        const resp = pregunta.respuestas.find(r => r.id === id);
                        return resp ? resp.nombre : id;
                      });
                      valorMostrar = nombresRespuestas.join(', ');
                      mostrarObservacion = respuesta.includes(RESPUESTA_OTROS);
                    } else if (pregunta.tipo === 'radio') {
                      // Para radio, mostrar el nombre de la respuesta seleccionada
                      const resp = pregunta.respuestas.find(r => r.id === respuesta);
                      valorMostrar = resp ? resp.nombre : respuesta;
                      mostrarObservacion = respuesta === RESPUESTA_OTROS;
                    } else {
                      // Para texto, mostrar directamente
                      valorMostrar = respuesta;
                    }
                  }

                  return (
                    <Box key={pregunta.id} mb={1.5}>
                      <Typography variant="body2" style={{ fontWeight: 500, marginBottom: 4 }}>
                        {pregunta.nombre}
                      </Typography>
                      <Typography variant="body2" color="textSecondary" style={{ fontSize: '0.85rem' }}>
                        {valorMostrar}
                      </Typography>
                      {mostrarObservacion && observacionOtro && (
                        <Box mt={0.5} pl={2}>
                          <Typography variant="body2" style={{ fontWeight: 500, fontSize: '0.8rem' }}>
                            Especificación:
                          </Typography>
                          <Typography variant="body2" color="textSecondary" style={{ fontSize: '0.8rem', fontStyle: 'italic' }}>
                            {observacionOtro}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  );
                })}
              </div>
            )}
          </DialogContent>
          <DialogActions className={classes.modalActions}>
            <Button
              onClick={() => this.setState({ modalDetalle: false })}
              size="small"
            >
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>

        {/* Confirmación de Envío */}
        <Dialog
          open={dialogoConfirmacion}
          maxWidth="xs"
          fullWidth
          className={classes.compactModal}
        >
          <DialogTitle className={classes.modalTitle}>
            Confirmar Envío
          </DialogTitle>
          <DialogContent className={classes.modalContent}>
            <Typography variant="body2">
              ¿Está seguro de que desea enviar todos los reportes?
            </Typography>
          </DialogContent>
          <DialogActions className={classes.modalActions}>
            <Button
              onClick={() => this.setState({ dialogoConfirmacion: false })}
              size="small"
            >
              Cancelar
            </Button>
            <Button
              onClick={this.confirmarEnvio}
              color="primary"
              variant="contained"
              size="small"
            >
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

//CARGO ESTADOS DEL MODULO
const mapStateToProps = (state) => {
  let { usuario } = state.redGlobal;
  return {
    usuario
  };
};

//CARGO FUNCIONES DEL MODULO
const mapDispatchToProps = {
  actualizarMensaje
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(NuevoReporte));